import { useState } from "react";
import { useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

const KEY = "age_verified";
export const isAgeVerified = () => localStorage.getItem(KEY) === "true";

export default function AgeGate({ children }) {
  const { pathname } = useLocation();
  const [ok, setOk] = useState(isAgeVerified);
  if (ok || ["/terms", "/privacy"].includes(pathname)) return children;

  const enter = () => { localStorage.setItem(KEY, "true"); setOk(true); };
  const leave = () => { window.location.href = "https://www.google.com"; };

  return (
    <div className="fixed inset-0 z-[200] bg-black flex items-center justify-center p-5" data-testid="age-gate">
      <div className="w-full max-w-md bg-surface border border-white/10 rounded-2xl p-6 sm:p-8 text-center">
        <div className="mx-auto w-14 h-14 rounded-full bg-brand/15 flex items-center justify-center mb-4">
          <ShieldAlert className="w-7 h-7 text-brand" />
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold mb-3" data-testid="age-gate-title">Adults Only (18+)</h1>
        <p className="font-bold text-sm sm:text-base leading-relaxed mb-3" data-testid="age-gate-disclaimer">
          AFTERHELLO is strictly for adults aged 18 or older. This platform contains adult-themed monetization,
          realistic AI companion interactions, and third-party advertising networks.
        </p>
        <p className="text-xs text-muted-foreground mb-6">
          All characters are AI-generated and fictional. By entering you confirm you are of legal age in your country
          and agree to our <a href="/terms" className="underline">Terms</a> and <a href="/privacy" className="underline">Privacy Policy</a>.
        </p>
        <div className="flex flex-col gap-3">
          <button data-testid="age-gate-enter" onClick={enter}
            className="h-12 rounded-full bg-brand hover:bg-brand-hover text-white font-semibold transition-colors">
            I am 18 or older - Enter
          </button>
          <button data-testid="age-gate-leave" onClick={leave}
            className="h-12 rounded-full border border-white/15 hover:bg-white/5 font-semibold transition-colors">
            Leave Site
          </button>
        </div>
      </div>
    </div>
  );
}
